import { useProvideCoreFetch } from '~/composables/useProvideCoreFetch'

import {
  hasTrackChartsRankStatus,
  hasTrackChartsRankWithNonRefundedStatus,
  provideFetchTrackChartsRank,
} from '~/api-core/Charts/FetchTrackChartsRank'

import type { FetchTrackChartsRankResponse } from '~/api-core/Charts/FetchTrackChartsRank'

export function useTrackChartsRank(trackId: MaybeRefOrGetter<number> = 0) {
  const { coreFetch } = useProvideCoreFetch()

  const { data: rankStatus, status } =
    useLazyAsyncData<FetchTrackChartsRankResponse>(
      `fetchTrackChartsRank-${toValue(trackId)}`,
      async () => {
        const id = toValue(trackId)
        if (!id) return { rank: null, status: null }

        const fetchTrackChartsRank = provideFetchTrackChartsRank(coreFetch)
        return await fetchTrackChartsRank(id)
      },
      // We defer the dedupe to avoid fetching the same data multiple times
      // since this component can be used multiple times in the same page
      { dedupe: 'defer', default: () => ({ rank: null, status: null }) },
    )

  const isLoadingStatus = computed(() => status.value === 'pending')

  return {
    rankStatus,
    isLoadingStatus,
    hasTrackChartsRankStatus,
    hasTrackChartsRankWithNonRefundedStatus,
  } as const
}
